import { render, staticRenderFns } from "./RegistrationLink.vue?vue&type=template&id=f02a41aa&scoped=true&"
import script from "./RegistrationLink.vue?vue&type=script&lang=js&"
export * from "./RegistrationLink.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLink.vue?vue&type=style&index=0&id=f02a41aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02a41aa",
  null
  
)

export default component.exports